export const DESIGN = 'design'
export const SELECTSLISTS = 'selectsLists'
